import { GetSuppliersAndCreatorsDto, Supplier } from "@/interfaces";
import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString,
  isNumber,
} from "@/utils";

export class SupplierHelper {
  static getSupplierId = (supplier?: Supplier | number): number | undefined =>
    isNonEmptyObject(supplier)
      ? (supplier as Supplier).supplierId
      : isNumber(supplier)
      ? (supplier as number)
      : undefined;

  static isSupplierEqual = (
    left?: Supplier | number,
    right?: Supplier | number
  ): boolean =>
    Boolean(left) &&
    Boolean(right) &&
    SupplierHelper.getSupplierId(left) === SupplierHelper.getSupplierId(right);

  static findSupplierIndex = (
    suppliers?: Supplier[] | number[],
    supplier?: Supplier | number
  ): number => {
    const supplierId = SupplierHelper.getSupplierId(supplier);

    return isNonEmptyArray(suppliers) && isNumber(supplierId)
      ? suppliers!.findIndex((item) =>
          SupplierHelper.isSupplierEqual(item, supplierId)
        )
      : -1;
  };

  static findSupplier = (
    suppliers?: Supplier[] | number[],
    supplier?: Supplier | number
  ) => {
    const supplierId = SupplierHelper.getSupplierId(supplier);

    return isNonEmptyArray(suppliers) && isNumber(supplierId)
      ? suppliers!.find((item) =>
          SupplierHelper.isSupplierEqual(item, supplierId)
        )
      : undefined;
  };

  static supplierExists = (
    suppliers?: Supplier[] | number[],
    supplier?: Supplier | number
  ) => (SupplierHelper.findSupplierIndex(suppliers, supplier) as number) >= 0;

  static getSupplierAndCreatorKey = (
    supplier?: GetSuppliersAndCreatorsDto | number,
    createdBy?: string
  ): string =>
    isNonEmptyObject(supplier)
      ? SupplierHelper.createSupplierAndCreatorKey(
          (supplier as GetSuppliersAndCreatorsDto).supplierId,
          (supplier as GetSuppliersAndCreatorsDto).createdBy
        )
      : isNumber(supplier)
      ? SupplierHelper.createSupplierAndCreatorKey(
          supplier as number,
          createdBy
        )
      : "";

  static createSupplierAndCreatorKey = (
    supplierId?: number,
    createdBy?: string
  ): string =>
    isNumber(supplierId)
      ? `${supplierId}${isNonEmptyString(createdBy) ? `-${createdBy}` : ""}`
      : "";
}
